import React from 'react';

interface RelationshipsInfinityIconProps {
  fill?: string;
  className?: string;
}

export const RelationshipsInfinityIcon: React.FC<RelationshipsInfinityIconProps> = ({
  fill = '#BCD7CF',
  className = '',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="121"
    height="56"
    viewBox="0 0 121 56"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M71.6571 33.1523C76.9381 38.6141 84.9143 45.6972 92.8267 45.6972C108.846 45.6972 116.902 26.2445 105.577 14.9201C102.314 11.6571 97.8065 9.63909 92.8267 9.63909C80.3421 9.63909 67.0397 27.3646 58.7057 36.6816C51.3766 44.7839 40.3582 55.3363 27.6871 55.3363C3.11963 55.3363 -9.26497 25.4922 8.12384 8.10339C13.1287 3.09853 20.0462 0.00115694 27.6871 0.00115694C38.4599 0.00115694 48.1087 7.68675 55.2565 14.9804L48.8711 22.2041C43.585 16.7374 35.6036 9.64423 27.6822 9.64423C11.6633 9.64423 3.60694 29.0969 14.9315 40.4213C18.1945 43.6843 22.7024 45.7023 27.6822 45.7023C40.4279 45.7023 54.1773 27.1081 62.8363 17.5199C70.1504 9.59835 80.7328 0 92.8205 0C117.388 0 129.773 29.8441 112.384 47.2329C107.379 52.2378 100.461 55.3351 92.8205 55.3351C82.0577 55.3351 72.4143 47.6596 65.2665 40.3752L71.6571 33.1523Z"
      fill={fill}
    />
  </svg>
);
